<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <ib-chip v-if="remaining.text" :color="$vuetify.theme.themes.light.primary" x-small  v-bind="attrs" v-on="on">
                <v-icon x-small left>mdi-whatsapp</v-icon>
                {{ remaining.text }}
            </ib-chip>
            <v-icon v-else color="error" x-small left  v-bind="attrs" v-on="on">mdi-timer-off-outline</v-icon>
        </template>
        <span>Tempo restante para responder</span>
    </v-tooltip>


</template>

<script>
export default {
    props: {
        deadline: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            remaining: this.$date.calcContextWindow(this.deadline) || { text: null },
            timer: null
        }
    },
    watch: {
        deadline() {
            this.updateCountdown();
            this.startTimer();
        }
    },
    methods: {
        startTimer() {
            clearInterval(this.timer);
            this.timer = setInterval(this.updateCountdown, 60000);
        },
        updateCountdown() {
            const result = this.$date.calcContextWindow(this.deadline);
            if (!result) {
                clearInterval(this.timer);
                this.remaining = { text: null };
            } else {
                this.remaining = result;
            }
        }
    },
    mounted() {
        this.startTimer();
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
}
</script>
